import React from "react";

function PeerToPeer() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  P2P Crypto Exchange Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Get your peer-to-peer (P2P) crypto exchange developed by our
                    experienced team of developers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PeerToPeer;
